import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Button, ButtonProps } from '@mui/material';
import React, { FC } from 'react';

export const venueConfigSectionActionSx = {
  justifyContent: 'flex-start',
  alignSelf: 'flex-start',
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '1.125rem',
  lineHeight: 1.6,
  letterSpacing: 0,
  color: 'text.primary',
  px: 0,
  py: 0.5,
  minHeight: 'unset',
  '&:hover': {
    backgroundColor: 'transparent',
    color: 'primary.main',
  },
  '& .MuiButton-endIcon': {
    marginLeft: '8px',
    color: 'primary.main',
  },
} as const;

export const venueConfigSectionActionSubtleSx = {
  justifyContent: 'flex-start',
  alignSelf: 'flex-start',
  textTransform: 'none',
  fontWeight: 500,
  fontSize: '0.875rem',
  lineHeight: 1.5,
  color: 'text.secondary',
  px: 0,
  py: 0.25,
  minHeight: 'unset',
  '&:hover': {
    backgroundColor: 'transparent',
    color: 'primary.main',
  },
  '& .MuiButton-endIcon': {
    marginLeft: '6px',
    color: 'text.secondary',
    fontSize: '1.125rem',
  },
} as const;

type VenueConfigSectionActionProps = {
  label: string;
  onClick: ButtonProps['onClick'];
  variant?: 'default' | 'subtle';
};

export const VenueConfigSectionAction: FC<VenueConfigSectionActionProps> = ({
  label,
  onClick,
  variant = 'default',
}) => (
  <Button
    variant="text"
    color="inherit"
    size={variant === 'subtle' ? 'small' : 'medium'}
    onClick={onClick}
    sx={variant === 'subtle' ? venueConfigSectionActionSubtleSx : venueConfigSectionActionSx}
    endIcon={<AddCircleOutlineIcon fontSize={variant === 'subtle' ? 'small' : 'medium'} />}>
    {label}
  </Button>
);
